import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Flex, Text, Heading, useDisclosure } from "@chakra-ui/react";
import { Tabs } from "antd";
import { WithAuth } from "@/hoc";
import { formatCurrency, formatDateAndHour, formattedCreditCardStatus, formattedCreditCardStatusColor ,showToast } from "@/utils";
import CreditCardManagement from "./_CreditCardManagement";
import { useCreditCard } from "@/hooks/useCreditCard";
import { DynamicTable } from "@/components/DynamicTable";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { DownloadIcon } from "@/styles/icons";
import { StatusModal } from "@/components";
import { Button, PageHeading,Pills } from "barte-design-system";
const CreditCardPage = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { getInitialCreditCardData, creditCardTransactionsData, downloadCreditCardStatement } = useCreditCard();
  const { id } = useParams();
  const { execute, loading: downloadLoading } = useAsyncFunction(downloadCreditCardStatement);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const tabs = [
    {
      tab: "Extrato",
      key: "ALL",
      status: "ALL",
    },
  ];
  async function getInitialData() {
    setLoading(true)
    try {
      await getInitialCreditCardData(id)
    } catch (error) {
      error?.response?.data?.errors.map((error) => {
        showToast({
          type: "error",
          message: `${error?.code} - ${error?.description}`,
        });
      });
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getInitialData();
  }, []);

  const { TabPane } = Tabs;
  const navigate = useNavigate();

  const columns = [
    {
      key: "transactionDate",
      title: "Lançamento",
      dataIndex: "transactionDate",
      render: (transactionDate: string) => (
        <Flex
          direction="column"
        >
          <Text 
            fontSize="md" 
            fontWeight="bold"
          >
            {formatDateAndHour(transactionDate).formattedDate}
          </Text>
          <Text 
            fontSize="sm" 
            color="gray.500"
          >
            {formatDateAndHour(transactionDate).formattedTime}
          </Text>
        </Flex>
      ),
    },
    {
      key: "description",
      title: "Operação",
      dataIndex: "description",
      sorter: false,
      emptyText: false,
      render: (description: string) => (
        <Flex align="center" gridGap="2">
          <Text>{description}</Text>
        </Flex>
      ),
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      sorter: false,
      emptyText: true,
    },
    {
      key: "",
      title: "",
      dataIndex: "",
      sorter: false,
      emptyText: true,
    },
    {
      key: "amount",
      title: "Valor",
      dataIndex: "amount",
      render: (amount: number) => (
        <Flex align="center" gridGap="2">
          <Text>{formatCurrency({value: amount})}</Text>
        </Flex>
      ),
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <>
          <Flex align="center" gridGap="2"> 
    
            <Pills label={formattedCreditCardStatus(status)} variant="light" state={formattedCreditCardStatusColor(status)} size="sm" />
          </Flex>
        </>
      ),
    },
  ];

  return (
    <>
      <StatusModal 
        isOpen={isOpen}
        status="success"
        message="O extrato será enviado para o seu e-mail."
        onClose={onClose}
      />
      <Flex 
          flexDir="column"
          width="100%"
          gap="1rem"
      >
        <PageHeading
          title="Cartão de crédito"
          onSecondaryAction={() => navigate("/cartao")}
          secondaryActionLabel="Gerenciar cartões"
          onBack={() => navigate(-1)}
        />
      
        <CreditCardManagement

        />
        <Tabs 
          defaultActiveKey="1" 
          className="tabs-custom"
        >
          {tabs.map(({ key, tab }) => (
            <TabPane tab={tab} key={key}>
                <Flex
                  w="100%"
                  flexDir="column"
                  gap="4"
                >
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      execute({ cardId: id }).then((res) => {
                        if(res.status === 200) {
                          onOpen();
                        }
                      });
                    }}
                    loading={downloadLoading}
                    disabled={downloadLoading}
                    style={{ marginLeft: "auto" }}
                    iconLeft={<DownloadIcon size={14} color="currentColor"/>}
                  >
                    Extrair extrato
                  </Button>
                <DynamicTable<any>
                  loading={loading}
                  columns={columns}
                  data={creditCardTransactionsData}
                  rowKey={(record) => record.id}
                  locale={{ emptyText: "Sem dados da fatura" }}
                  
                />
              </Flex>
            </TabPane>
          ))}
        </Tabs>
      </Flex>
    </>
  );
};

export default WithAuth(CreditCardPage);
